export async function loadShopifyAppBridge() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("shop") && !params.has("host")) return;
  if ((window as Window & { shopify?: unknown }).shopify) return;
  await new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://cdn.shopify.com/shopifycloud/app-bridge.js";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Shopify App Bridge could not load."));
    document.head.appendChild(script);
  });
}
